"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormError = void 0;
var FormError;
(function (FormError) {
    FormError["invalidArray"] = "This is invalid";
    FormError["invalidEmail"] = "Email is invalid!";
    FormError["notAllowedValue"] = "Not allowed value!";
    FormError["required"] = "Field is required!";
    FormError["tooLong"] = "Too long!";
    FormError["tooShort"] = "Too short!";
    FormError["notMatchedPasswords"] = "Passwords do not match!";
    FormError["moreThenLimit"] = "More than the maximum!";
    FormError["lessThenLimit"] = "Less than the minimum.";
    FormError["mustBeTrue"] = "Value must be true";
})(FormError = exports.FormError || (exports.FormError = {}));
//# sourceMappingURL=errors.js.map